import InfraInventarioPantallas from "../../components/InfraInventarioPantallas";

export const InfraInventarioPantallasPage = () => <InfraInventarioPantallas />;
